import { gql } from "@apollo/client";
import { useGetGlobalSearchResultsQuery } from "src/gql/codegen/graphql";
import { useSession } from "src/components/session/session";
import "./cache/populateCachedResults";

export default function useGetGlobalSearchResults(searchString: string) {
  const session = useSession();

  return useGetGlobalSearchResultsQuery({
    context: { session },
    variables: {
      input: { search_term: searchString },
    },
    fetchPolicy: searchString === "" ? "cache-only" : "cache-first",
  });
}

gql`
  query GetGlobalSearchResults($input: GlobalSearchInput!) {
    global_search(input: $input) {
      dashboards {
        id
        name
        slug
        owner {
          handle
          id
          name
          profile_image_url
          type
        }
      }
      queries {
        id
        name
        owner {
          handle
          id
          name
          profile_image_url
          type
        }
      }
      teams {
        handle
        id
        name
        profile_image_url
        type
      }
      users {
        handle
        id
        name
        profile_image_url
        type
      }
    }
  }
`;
